import ContentLayout from "@/components/layout/Layout";

const Dashboard = () => import(/* webpackChunkName: "Page" */"@/pages/Home/Dashboard");
const NotFound = () => import(/* webpackChunkName: "Page" */"@/pages/NotFound");
const Login = () => import(/* webpackChunkName: "Page" */"@/pages/Login");
const Callback = () => import(/* webpackChunkName: "Page" */"@/pages/oauth2/Callback");
const SignOut = () => import(/* webpackChunkName: "Page" */"@/pages/oauth2/SignOut");
const Warehouse = () => import(/* webpackChunkName: "Page" */"@/pages/Config/Warehouse/Index");

// Admin region
const Actions = () => import(/* webpackChunkName: "Admin" */"@/pages/Admin/Permission/Actions/Index");
const Resources = () => import(/* webpackChunkName: "Admin" */"@/pages/Admin/Permission/Resources/Index");
const Permission = () => import(/* webpackChunkName: "Admin" */"@/pages/Admin/Permission/Permission/Index");
const Roles = () => import(/* webpackChunkName: "Admin" */"@/pages/Admin/Permission/Roles/Index");
const RoleUser = () => import(/* webpackChunkName: "Admin" */"@/pages/Admin/Permission/RoleUser/Index");

const routes = [
  {
    path: "/",
    component: ContentLayout,
    children: [
      {
        path: "",
        name: "Trang chủ",
        component: Dashboard
      },
      {
        path: "error-request",
        name: "Quản lý lỗi",
        component: () => import(/* webpackChunkName: "Page" */"@/pages/ErrorRequest/Index")
      },
      {
        path: "support-shop",
        name: "Tiện tích hỗ trợ theo shop",
        component: () => import(/* webpackChunkName: "Page" */"@/pages/SupportShop/Index")
      },
      {
        path: "products/delete",
        name: "Xóa sản phẩm",
        component: () => import(/* webpackChunkName: "Page" */"@/pages/Products/Delete")
      },
      {
        path: "products/inventory",
        name: "Cân chỉnh hàng tồn kho",
        component: () => import(/* webpackChunkName: "Page" */"@/pages/Products/UpdateInventory")
      },
      {
        path: "package",
        name: "Đơn hàng",
        component: () => import(/* webpackChunkName: "Page" */"@/pages/Package/Index")
      },
      {
        path: "package/export",
        name: "Xuất đơn hàng",
        component: () => import(/* webpackChunkName: "Page" */"@/pages/Package/export/Index")
      },
      {
        path: "package/mng",
        name: "Quản lý trạng thái đơn hàng",
        component: () => import(/* webpackChunkName: "Page" */"@/pages/Package/mng/Index")
      },
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/report",
    component: ContentLayout,
    children: [
      {
        path: "inventory",
        name: "Xuất báo cáo kiểm kho",
        component: () => import(/* webpackChunkName: "Page" */"@/pages/Reports/Index")
      },
      {
        path: "station/inventory",
        name: "Xuất báo cáo tồn bưu cục",
        component: () => import(/* webpackChunkName: "Page" */"@/pages/Reports/StationInventory")
      },
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/config",
    component: ContentLayout,
    children: [
      {
        path: "warehouse",
        name: "Quản lý cấu hình kho FF",
        component: Warehouse
      },
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/admin",
    component: ContentLayout,
    children:[
      {
        path: "authenticate",
        name: "Quản lý mã xác thực API",
        component: () => import(/* webpackChunkName: "Page" */"@/pages/Admin/Authenticate/Index")
      },
      {
        path: "system-config-properties",
        name: "Cấu hình hệ thống",
        component: () => import(/* webpackChunkName: "Page" */"@/pages/Admin/SystemConfigProperties/Index")
      },
      {
        path: "system-config",
        name: "Cấu hình service",
        component: () => import(/* webpackChunkName: "Page" */"@/pages/Admin/SystemConfig/Index")
      }
    ]
  },
  {
    path: "/admin/permission",
    component: ContentLayout,
    children: [
      {
        path: "resources",
        name: "Quản lý tài nguyên của hệ thống",
        component: Resources
      },
      {
        path: "actions",
        name: "Quản lý hành động",
        component: Actions
      },
      {
        path: "permission",
        name: "Quản lý quyền",
        component: Permission
      },
      {
        path: "roles",
        name: "Quản lý vai trò",
        component: Roles
      },
      {
        path: "role-user",
        name: "Phân quyền user",
        component: RoleUser
      },
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/oauth2/callback",
    component: Callback,
    meta: {
      guest: true
    }
  },
  {
    path: "/sign-out",
    component: SignOut,
    meta: {
      guest: true
    }
  },
  {
    path: "/moshop",
    component: ContentLayout,
    children:[
      {
        path: "shop-feature",
        name: "Cấu hình tính năng cho shop",
        component: () => import(/* webpackChunkName: "Moshop" */"@/pages/Moshop/FeatureShop/Index")
      }
    ]
  },
  {path: "*", component: NotFound},
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
